
import { appConfigProd, aadProd, IEnvironment, mobileProd , versions } from '@orga-app/env';

export const environment = <IEnvironment>{
  production: true,
  loginRoute: '/login',
  homeRoute: "/home",
  debug: false,
  testMode: false,
  appTitle: "PROD",
  appConfig: appConfigProd,
  azureAd: aadProd,
  version: versions.version,
  mobile: mobileProd,
  hankoUrl: 'https://auth.orgarena.de',
};
